<template>
  <div class="wrapper blue" v-if="loading">
    <h1><i class="eva eva-loader-outline spin" /> Loading...</h1>
  </div>
  <div v-else-if="editing">
    <h1 class="title-header">
      <span class="full-width">Edit Mode</span
      ><button class="btn" @click="stopEditing()">Retour</button
      ><button class="btn success" @click="save()">Envoyer</button>
    </h1>
    <div class="header">
      Project<input v-model="project" />, Key:<input v-model="key" />
    </div>
    <ckeditor :editor="editor" v-model="value" :config="editorConfig"></ckeditor>
  </div>
  <div class="container" v-else>
    <h1>DASHBOARD</h1>
    <div class="list-item" v-for="(page, index) in pages" :key="index">
      <h2>
        {{ page.name }}
        <button class="btn primary" @click="add(page.name)">
          Add page to project {{ page.name }}
        </button>
        <button class="btn danger" @click="deleteProject(page.name)">
          Delete project {{ page.name }}
        </button>
      </h2>
      <div>
        <div v-for="(el, elIndex) in page.elements" :key="elIndex" class="list-elem">
          <span class="elem-title">{{ el.name }}</span>
          <button class="btn warning" @click="edit(page.name, el.name, el.value)">
            Edit
          </button>
          <button class="btn danger" @click="del(page.name, el.name)">Delete</button>
        </div>
      </div>
    </div>
    <button class="btn primary" @click="createProject()">Crate new project</button>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  name: "Admin",

  mounted() {
    this.fetchPages();
  },

  data() {
    return {
      loading: false,
      editing: false,
      pages: [],
      value: "",
      project: "",
      key: "",
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
      },
    };
  },

  methods: {
    async fetchPages() {
      this.pages = [];
      this.loading = true;
      try {
        const response = await this.$firebase.firestore().collection("all").get();
        console.log("response", response);
        if (response) {
          response.forEach((doc) => {
            const data = doc.data();
            const elements = [];
            for (const [key, value] of Object.entries(data)) {
              console.log(`${key}: ${value}`);
              elements.push({ name: key, value });
            }

            this.pages.push({ name: doc.id, elements });
          });
        }
      } catch (err) {
        alert(JSON.stringify(err));
      }
      this.loading = false;
    },

    async del(project, key) {
      this.loading = true;
      await this.$firebase
        .firestore()
        .collection("all")
        .doc(project)
        .update({ [key]: this.$firebase.firestore.FieldValue.delete() });
      await this.fetchPages();
      this.loading = false;
    },

    async deleteProject(project) {
      this.loading = true;
      await this.$firebase.firestore().collection("all").doc(project).delete();
      await this.fetchPages();
      this.loading = false;
    },

    edit(project, key, value) {
      this.editing = true;
      this.project = project;
      this.key = key;
      this.value = value;
    },

    createProject(project, key, value) {
      this.editing = true;
      this.project = project;
      this.key = key;
      this.value = value;
    },

    add(project) {
      console.log("project", project, this.project);
      this.project = project;
      this.editing = !this.editing;
    },

    async save() {
      this.loading = true;
      let obj = {};
      obj[this.key] = this.value;
      if (!this.key) {
        alert("Please provide a key and project");
        return;
      }
      await this.$firebase
        .firestore()
        .collection("all")
        .doc(this.project)
        .set(obj, { merge: true });
      await this.fetchPages();
      this.editing = false;
      this.loading = false;
    },

    stopEditing() {
      this.editing = false;
    },
  },
};
</script>

<style>
.title-header {
  display: flex;
  flex-direction: row;
  align-content: center;
  flex: 1;
  width: 100%;
}
.full-width {
  display: flex;
  flex: 1;
  width: 100%;
}
* {
  text-align: left;
}
.header {
  margin: 40px 10px;
}
.list-item {
  padding: 20px;
  border-radius: 10px;
}
.list-elem {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 10px;
  background-color: #f7f7f7;
  padding: 10px;
}
.list-elem + .list-elem {
  margin-top: 10px;
}
h2 {
  text-align: left;
}
.btn {
  padding: 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  color: #fff;
  background-color: #2b2d38;
}
.elem-title {
  display: flex;
  flex: 1;
}
.btn + .btn {
  margin-left: 10px;
}
.warning {
  background-color: #f5a831;
}
.danger {
  background-color: #ed4b6f;
}
.primary {
  background-color: #3365fb;
}
.success {
  background-color: #3be06e;
}
</style>
